<template>
	<div class="scroll-container">
		<Survey v-bind:questions="questions" :previous-component-name="previousComponentName"/>
	</div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import Survey from '@/components/Survey.vue';
import { authTokenService } from '@/services/authTokenService.js';
import { surveyService } from '@/services/surveyService.js';
import { authService } from '@/services/authService.js';

export default {
	name: 'home',
	components: {
		Survey
	},
	data: () => ({
		questions: [],
		previousComponentName: null
	}),
	methods: {
		parseQuestions (questions) {
			if (questions && questions.length > 0) {
				const len = questions.length;
				for (let idx = 0; idx < len; idx++) {
					let q = questions[idx];

					if (q.bullets) {
						const bulletsText = q.bullets.replace(/[\n\r]/g, '');
						const bullets = JSON.parse(bulletsText);
						q.bullets = bullets;
					}

					if (q.columns) {
						const columnsText = q.columns.replace(/[\n\r]/g, '');
						const columns = JSON.parse(columnsText);
						q.columns = columns;
					}

					if (q.explaination) {
						const explainationText = q.explaination.replace(/[\n\r]/g, '');
						const explaination = JSON.parse(explainationText);
						q.explaination = explaination;
					}

					// casting a string into a boolean checks if that string is null, or empty
					if (q.crossCheck && Boolean(q.crossCheck)) {
						const crossCheckText = q.crossCheck.replace(/[\n\r]/g, '');
						const crossCheck = JSON.parse(crossCheckText);
						q.crossCheck = crossCheck;
					}
				}
			}
		},
		logout () {
			authService.logout();
		}
	},
	mounted () {
		debugger;
		const me = this;
		me.previousComponentName = me.$route.params.previousComponentName;
		let surveyId = authTokenService.getActiveSurveyId();
    	// Call the store action to load section status info
		me.$store.dispatch('validation/loadQuestionStatuses');
		me.$store.dispatch('validation/loadSurveyValidationMessages');
		me.$store.dispatch('loadAllAnswers', { surveyId: surveyId, qId: 0 });

		surveyService.getSurvey(surveyId).then(function (response) {
			if (response && response.data) {
				const questions = response.data;
				me.parseQuestions(questions);
				let idx = 0;
				questions.forEach(element => {
					Vue.set(me.questions, idx++, element);
				});
    		}
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
	}
};
</script>

<style scoped>
	.topMenu {
		position: fixed;
	}
</style>
